import React from 'react'

import Svg, { Circle, ClipPath, Defs, G, Path } from 'react-native-svg'

const Shield = ({ ...props }) => {
  return (
    <Svg
      width={98}
      height={98}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#a)">
        <Path
          d="M88.266 11.653 49.826.121a2.87 2.87 0 0 0-1.65 0L9.733 11.653a2.87 2.87 0 0 0-2.046 2.75v42.285c0 5.5 2.227 11.13 6.618 16.734 3.353 4.28 7.993 8.577 13.79 12.773 9.738 7.05 19.328 11.374 19.73 11.554a2.87 2.87 0 0 0 2.347 0c.404-.18 9.993-4.504 19.731-11.554 5.797-4.196 10.437-8.493 13.79-12.773 4.391-5.604 6.618-11.234 6.618-16.734V14.403a2.87 2.87 0 0 0-2.046-2.75Z"
          fill="#5E9FFF"
        />
        <Path
          d="M88.266 11.653 49.826.121A2.872 2.872 0 0 0 49 0v98c.4 0 .8-.084 1.173-.25.404-.181 9.993-4.505 19.731-11.555 5.797-4.196 10.437-8.493 13.79-12.773 4.391-5.604 6.618-11.234 6.618-16.734V14.403a2.87 2.87 0 0 0-2.046-2.75Z"
          fill="#145CC5"
        />
        <Circle cx={50} cy={49} r={25} fill="#fff" />
        <Path
          d="m66.117 45.88-.824 2.037c-.26.693-.26 1.43 0 2.123l.824 2.037a2.86 2.86 0 0 1-.997 3.38l-1.82 1.256c-.607.434-.997 1.084-1.17 1.777l-.39 2.167c-.26 1.3-1.343 2.253-2.643 2.296l-2.21.087a2.997 2.997 0 0 0-1.95.867L53.42 65.51c-.91.953-2.34 1.17-3.467.52l-1.906-1.127c-.65-.39-1.387-.476-2.124-.303l-2.166.52a2.88 2.88 0 0 1-3.207-1.473l-.997-1.994c-.346-.65-.91-1.17-1.603-1.386l-2.08-.694a2.818 2.818 0 0 1-1.907-2.946l.217-2.21a2.665 2.665 0 0 0-.607-2.037l-1.386-1.733a2.803 2.803 0 0 1 0-3.51l1.386-1.734c.477-.563.694-1.3.607-2.036l-.217-2.21c-.13-1.3.65-2.514 1.907-2.947l2.08-.693c.693-.217 1.257-.737 1.603-1.387l.997-1.993a2.855 2.855 0 0 1 3.207-1.474l2.166.52a2.825 2.825 0 0 0 2.124-.303l1.906-1.127c1.127-.65 2.557-.476 3.467.52l1.517 1.604c.52.52 1.213.866 1.95.866l2.21.087c1.3.043 2.426.997 2.643 2.297l.39 2.166c.13.737.563 1.387 1.17 1.777l1.82 1.257c1.083.953 1.517 2.34.997 3.553Z"
          fill="#00D566"
        />
        <G opacity={0.15} fill="#000">
          <Path d="m41.807 63.517-.997-1.994c-.347-.65-.91-1.17-1.603-1.386l-2.08-.694a2.818 2.818 0 0 1-1.907-2.946l.217-2.21a2.664 2.664 0 0 0-.607-2.037l-1.387-1.733a2.803 2.803 0 0 1 0-3.51l1.387-1.734c.477-.563.693-1.3.607-2.036l-.217-2.21c-.13-1.3.65-2.514 1.907-2.947l2.08-.693c.693-.217 1.256-.737 1.603-1.387l.997-1.993a2.782 2.782 0 0 1 1.603-1.387 2.734 2.734 0 0 0-2.86 1.517l-.997 1.993c-.346.65-.91 1.17-1.603 1.387l-2.08.693a2.818 2.818 0 0 0-1.907 2.947l.217 2.21a2.665 2.665 0 0 1-.607 2.036l-1.386 1.734a2.803 2.803 0 0 0 0 3.51l1.386 1.733c.477.563.694 1.3.607 2.037l-.217 2.21c-.13 1.3.65 2.513 1.907 2.946l2.08.694c.693.216 1.257.736 1.603 1.386l.997 1.994a2.855 2.855 0 0 0 3.207 1.473l.26-.043c-.954-.174-1.777-.694-2.21-1.56ZM49.26 32.75l1.907-1.127c.173-.086.346-.173.52-.216a2.81 2.81 0 0 0-1.777.346l-1.907 1.127a2.653 2.653 0 0 1-.52.217c.607.086 1.214 0 1.777-.347ZM58.1 62.867a2.56 2.56 0 0 0-.607.086l1.56-.086c.217 0 .39-.044.607-.087l-1.56.087ZM51.167 65.857 49.26 64.73c-.65-.39-1.387-.477-2.123-.303l-.26.043c.39.043.736.173 1.083.347l1.907 1.126c.736.434 1.56.477 2.34.217-.347 0-.694-.087-1.04-.303Z" />
        </G>
        <Path d="m42.067 46.227 5.416 6.196 11.094-8.926" fill="#00D566" />
        <Path
          d="M46.183 55.63c-.606 0-1.213-.26-1.646-.737l-5.417-6.196a2.229 2.229 0 0 1 .173-3.077 2.229 2.229 0 0 1 3.077.173l4.073 4.637 9.49-7.627c.91-.736 2.297-.606 3.034.347.736.953.606 2.297-.347 3.033l-11.093 8.97a2.21 2.21 0 0 1-1.344.477Z"
          fill="#fff"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 0h98v98H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default Shield
